import { Checkbox } from '@billy/design-system'
import { MouseEvent, ReactElement } from 'react'

import * as Styled from './styles'

interface ReviewEntriesSelectCellProps {
  checked: boolean
  name: string
  onChange: () => void
}

const stopClickPropagation = (event: MouseEvent<HTMLDivElement>) => {
  event.stopPropagation()
}

export const ReviewEntriesSelectCell = ({ checked, name, onChange }: ReviewEntriesSelectCellProps): ReactElement => (
  <Styled.SelectCellWrapper onClick={stopClickPropagation} role="presentation">
    <Checkbox checked={checked} name={name} onChange={onChange} />
  </Styled.SelectCellWrapper>
)
